module.exports = __webpack_public_path__ + "asset/image/sign-in-010a.jpg";